function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.265 3.867c-.505-.214-.72-.84-.417-1.294C4.46 1.663 5.484 1 6.835 1c1.484 0 2.501.676 3.02 1.522.441.726.7 2.084.018 3.095-.758 1.118-1.484 1.459-1.876 2.179-.094.17-.151.31-.19.593a.92.92 0 01-.902.822c-.55 0-.998-.474-.935-1.024.038-.322.114-.656.29-.972.487-.878 1.422-1.396 1.965-2.173.575-.815.252-2.337-1.377-2.337-.739 0-1.219.386-1.516.847-.22.36-.682.473-1.067.315zm3.84 7.87c0 .695-.569 1.263-1.263 1.263a1.267 1.267 0 01-1.264-1.263c0-.695.569-1.263 1.264-1.263.694 0 1.263.568 1.263 1.263z",
  fill: "currentColor"
});

var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgQuestion;